import Vue from "vue";
import VueResource from "vue-resource";
import ApiAuth from "../models/ApiAuth.js";
import RxeobAutocomplete from "../components/RxeobAutocomplete.vue";
import Buefy from 'buefy';
import Default from "../models/Default.js";
import toast from "../../node_modules/buefy/dist/components/toast";
import Account from "../models/Account.js";
import Benefit from "../models/Benefit.js";
import globalStore from '../models/variables.js';

Vue.use(Buefy);
Vue.use(VueResource);
Vue.use(toast);
/***************************************/

// add to all vue-resource request headers
var headers = { Accept: "application/json" };
ApiAuth.addAuthHeader(headers);
Account.initializeHeaders(headers);

Default.initializeHeaders(headers);
Benefit.initializeHeaders(headers);

for (var k in headers) {
    Vue.http.headers.common[k] = headers[k];
}
var personApi = Vue.resource(Apollo.resolveApiUrl('~/Person'), {}, {
    currentUser: { method: 'GET', url: Apollo.resolveApiUrl('~/Person/Me') }
});

var searchApi = Vue.resource(Apollo.resolveApiUrl('~/Pharmacy'), {}, {
    searchArea: { method: 'GET', url: Apollo.resolveApiUrl('~/Pharmacy/QueryArea') }
});


var PharmacySearchApp = new Vue({
    el: "#pharmacy-search-app",
    components: {
        RxeobAutocomplete: RxeobAutocomplete
    },
    data: {
        defaults: [],
        user: {},
        searchPlaceholderText: "",
        rxwalletText: "",
        RxWalletSSO: false,
        TrueRxWalletSSO: false,
        searchButtonText: "",
        clearButtonText: "",
        noResultsText: "",
        useCurrentLocationText: "",
        inNetworkOnlyText: "",
        inHouseOnlyText: "",
        pharmacyHelpBannerText: "",
        latitude: '38.768',
        long: '-98.340',
        latParam: "",
        longParam: "",
        currentPharmacy: null,
        searchRad: 1,
        searchAddress: '',
        searchName: '',
        searchCity: '',
        searchState: '',
        searchZip: '',
        isBordered: true,
        isStriped: true,
        pharmacies: [],
        columns: [
            { field: 'DisplayDistance', label: 'Distance', width: 100 },
            { field: 'DisplayName', label: 'Pharmacy', renderHtml: true },
            { field: 'DisplayInNetwork', label: 'Network/Pharmacy Type', renderHtml: true }
        ],
        zoom: 4,
        searchZoom: 13,
        markerZoom: 14,
        ne: null,
        sw: null,
        googleAutocomplete: null,
        processLocationSearch: false,
        networkOnly: true,
        inHouseOnly: false,
        infoWindow: undefined,
        state: {
            hasResults: false
        },
        benefits: [],
        searchOpts: {
            ln: "",
            pricingMode: null,
            pricingModeCompare: null,
            quantity: "30",
            daysSupply: "30",
            customQuantity: null,
            customDaysSupply: null,
            benefitId: null
        },
        localvar: globalStore,
        primaryPersonId: "",
        currentHealthPlanId: "",
        currentPersonId: "",
        isEmulated: "",
        currentLocationErrorText: "",
    },
    methods: {
        loadDefaults: function () {
            var me = this;
            Default.GetForView("pharmacy_search").then(function (res) {

                me.defaults = res.data;
                me.loadText();

                for (var i = 0; i < me.columns.length; i++) {

                    if (me.columns[i]["label"] === "Distance") {
                        me.columns[i]["label"] = me.getDefault("distance");

                    }
                }

                for (var i = 0; i < me.columns.length; i++) {

                    if (me.columns[i]["label"] === "Pharmacy") {
                        me.columns[i]["label"] = me.getDefault("pharmacy");

                    }
                }

                for (var i = 0; i < me.columns.length; i++) {

                    if (me.columns[i]["label"] === "Network/Pharmacy Type") {
                        me.columns[i]["label"] = me.getDefault("Network_Pharmacy_Type");

                    }
                }

            });
        },
        setEmulationStatus: function () {
            var me = this;
            Account.get().then(function (response) {
                me.primaryPersonId = response.data.PrimaryEligibility.PersonId;
                Account.getCurrentPerson().then(function (response) {
                    me.currentHealthPlanId = response.data.HealthPlanId;
                    me.currentPersonId = response.data.PersonId;
                    if (me.primaryPersonId != me.currentPersonId) {
                        console.log("here")
                        me.isEmulated = true;
                        me.RxWalletSSO = false;
                    } else if (me.RxWalletSSO == true) {
                        me.TrueRxWalletSSO = true;
                    }
                }).catch(function (error) {
                    console.log(error);
                });
            }).catch(function (error) {
                console.log(error);
            });
        },
        getDefault: function (nameKey) {
            return Default.Find(nameKey, this.defaults);
        },
        loadText: function () {
            this.searchPlaceholderText = this.getDefault("search_placeholder");
            this.searchButtonText = this.getDefault("search");
            this.clearButtonText = this.getDefault("clear");
            this.noResultsText = this.getDefault("no_results");
            this.useCurrentLocationText = this.getDefault("use_current_location");
            this.inNetworkOnlyText = this.getDefault("in_network_only");
            this.inHouseOnlyText = this.getDefault("in_house_only");
            this.pharmacyHelpBannerText = this.getDefault("pharmacy_help_banner");
            this.rxwalletText = this.getDefault("go_to_rxwallet_button");
            this.currentLocationErrorText = this.getDefault("current_location_error");
        },
        loadBenefits: function () {

            var me = this;
            Benefit.get().then(function (res) {
                me.benefits = res.data;
                me.searchOpts.benefitId = me.benefits[0].Id;
                me.loadPricingModes();
            });
        },
        loadPricingModes: function () {
            var me = this;

            var int_id = parseInt(me.searchOpts.benefitId);
            for (var i = 0; i < this.benefits.length; i++) {
                if (int_id === parseInt(this.benefits[i].Id)) {
                    if (this.benefits[i].Name.includes("Medicare") || this.benefits[i].Name.includes("Advantage") || this.benefits[i].Name.includes("ADVANTAGE")) {
                        globalStore.updateItem("Medicare");
                        globalStore.$forceUpdate();
                        break;
                    }
                }
            }
        },
        getUser: function () {
            var me = this;

            Account.getUser().then(function (response) {
                me.user = response.data;
                // set default In-Network toggle to true for LVHN only
				me.inHouseOnly = me.user.HealthPlanId === 57;
                me.networkOnly = true;
            }).catch(function (error) {
                console.log(error);
            });
        },
        /**
         * Handler for clear button on the autocomplete component
         * */
        clear: function () {

            this.pharmacies = [];
            this.refreshMap();
        },
        /**
         * Handler for the Google Places Autocomplete widget, grabs the best match if the user hits enter or search etc without actually selecting an item from the drop down
         * */
        autoCompleteHandler: function () {
            var me = this;
            var thePlace = this.googleAutocomplete.getPlace();
            //didnt get a place from the widget, get the best prediction and geocode it.
            if (thePlace.geometry == undefined) {
                me.$refs.autocomplete.inputVal = this.googleAutocomplete.gm_accessors_.place.Uc.A[0].B[0];
                var me = this;
                var geocoder = new google.maps.Geocoder();
                geocoder.geocode({ 'address': this.searchName }, function (results, status) {
                    if (status == google.maps.GeocoderStatus.OK) {
                        //best match
                        me.latitude = results[0].geometry.location.lat();
                        me.long = results[0].geometry.location.lng();
                        window.map.panTo({ lat: me.latitude, lng: me.long });
                        window.map.setZoom(me.searchZoom);
                    }
                });
            }
            //center in on the place that the user selected, and run the search using the viewable area of the map
            else {
                this.latitude = thePlace.geometry.location.lat();
                this.long = thePlace.geometry.location.lng();
                window.map.panTo({ lat: this.latitude, lng: this.long });
                window.map.setZoom(me.searchZoom);
                me.$refs.autocomplete.inputVal = thePlace.formatted_address;
                this.processLocationSearch = false;
            }
            this.runAreaSearch();
        },

        /**
         * Runs a pharmacy search using the viewable area on the map
         * */
        runAreaSearch: function () {
            var me = this;

            if (!me.networkOnly) {
                me.inHouseOnly = false;
            }

            const loadingComponent = this.$buefy.loading.open({
                container: true ? null : me.$refs.element.$el
            })
            //grab the map bounds and send to webservice to search viewable area of map
            var bounds = window.map.getBounds();
            this.zoom = window.map.getZoom();
            this.ne = bounds.getNorthEast();
            this.sw = bounds.getSouthWest();
            this.latitude = window.map.center.lat().toString(),
                this.long = window.map.center.lng().toString(),
                searchApi.searchArea({
                    lat: me.latitude,
                    lng: me.long,
                    neLat: me.ne.lat().toString(),
                    neLng: me.ne.lng().toString(),
                    swLat: me.sw.lat().toString(),
                    swLng: me.sw.lng().toString(),
                    name: '',
                    network_only: me.networkOnly,
                    in_house_only: me.inHouseOnly
                }).then(function (response) {
                    me.pharmacies = response.body;
                    console.log(me.pharmacies)
                    for (var i = 0; i < me.pharmacies.length; i++) {
                        //some formatting to the pharmacy information that will display
                        var current = me.pharmacies[i];
                        if (current.Zip.length > 5) {
                            current.Zip = current.Zip.substring(0, 5) + "-" + current.Zip.substring(5);
                        }
                        if (current.Zip.length < 5) {
                            current.Zip.ToString("00000");
                        }
                        var newphone = current.Phone.replace("(", "")
                        newphone = newphone.replace(")", "")
                        newphone = newphone.replace(" ", "")
                        newphone = newphone.replace("-", "")

                        var new_name = current.Name + "<br>" + current.AddressLine1 + "<br>" + current.City + ", " + current.State + ", " + current.Zip + '<br><a href="tel:' + newphone + '">' + current.Phone + '</a>';
                        var network = me.getDefault("non_Network");
                        if (current.InNetwork === true) {
                            network = me.getDefault("in_network");

                            // add In-House / Retail indicator if client is LVHN
                            if (me.user.HealthPlanId === 57) {
                                network += " | " + me.getDefault((current.NetworkStatus === "LVPS") ? "in_house" : "retail");
                            }
                        }
                        console.log(network, current.DispenserTypeDescription)
                        if (current.DispenserTypeDescription != null) {
                            network = network + "<br>" + current.DispenserTypeDescription;
                        }
                        if (current.PharmacyNotes.length > 0) {
                            var notes = "";
                            current.PharmacyNotes.every(function (item) {
                                if (item.Suppression == true) {
                                    notes = "<br>" + item.DisplayTextEnglish;
                                    return false;
                                } else {
                                    notes += "<br>" + item.DisplayTextEnglish;
                                }
                                return true;
                            });
                            network += notes;
                        }

                        current.DisplayDistance = parseFloat(current.Distance).toFixed(2).toString() + " mi.";
                        current.DisplayName = new_name;
                        current.DisplayInNetwork = network;
                    }
                    me.refreshMap();
                    window.setTimeout(function () { me.state.hasResults = true; }, 1000);
                    loadingComponent.close();
                });
        },
        /**
         *reset map get all the results on it, refresh all the markers too etc
         * */
        refreshMap: function () {
            var me = this;
            window.map = new google.maps.Map(document.getElementById('map'), {
                zoom: me.zoom,
                center: { lat: Number(me.latitude), lng: Number(me.long) },
                mapTypeControl: false,
                fullscreenControl: false,
                minZoom: 4,
                maxZoom: 16
            });

            //window.map.addListener("dragend", function () {
            //    console.log("dragend");
            //    google.maps.event.addListenerOnce(window.map, 'idle', function () {
            //        me.runAreaSearch();
            //    });
            //});

            var showInfo = function (marker) {
                if (this.Zip.length < 5) {
                    this.Zip.ToString("00000");
                }
                var newphone = this.Phone.replace("(", "")
                newphone = newphone.replace(")", "")
                newphone = newphone.replace(" ", "")
                newphone = newphone.replace("-", "")

                var infowindow = new google.maps.InfoWindow({
                    content: '<div style="text-align:center;">' + this.Name + '<br>' + this.AddressLine1 + '<br>' + this.City + ', ' + this.State + ', ' + this.Zip + '<br><a href="tel:' + newphone + '">' + this.Phone + '</a></div>'
                });
                if (me.infowindow) {
                    me.infowindow.close();
                }
                me.infowindow = infowindow;
                window.map.panTo(marker.getPosition());
                infowindow.open(window.map, marker);
                window.map.setZoom(me.markerZoom);
                me.bindInfoWindowCloseClick(infowindow);
            }
            this.pharmacies.forEach(function (thePharmacy) {
                var marker = new google.maps.Marker({
                    position: { lat: Number(thePharmacy.Latitude), lng: Number(thePharmacy.Longitude) },
                    map: window.map
                });
                thePharmacy.marker = marker;
                thePharmacy.showInfo = showInfo;
                me.bindMarkerClick(thePharmacy);
            });
            
        },
        /**
         * Handler when an item in the list/table is selected
         * @param {Object} p = the pharmacy object
         */
        pharmacyClick: function (p) {
            this.currentPharmacy = p;
            p.showInfo(p.marker);
            console.log(p);

        },
        /**
         * handler for when the info window is closed (the window that shows on the map above the marker)
         * @param {any} infoWindow
         */
        bindInfoWindowCloseClick: function (infoWindow) {
            var me = this;
            google.maps.event.addListener(infoWindow, 'closeclick', function () {
                me.currentPharmacy = null;
            });
        },
        /**
         * handler when a marker on the map is clicked
         * @param {any} aPharmacy
         */
        bindMarkerClick: function (aPharmacy) {
            var me = this;
            google.maps.event.addListener(aPharmacy.marker, 'click', function () {
                me.pharmacyClick(aPharmacy);
                var pList = $("#pharmacy-list");
                var pItem = $("." + aPharmacy.Id);
                var width = $(document).width();
                //this is wild, scroll the pharmacy list item into the center of the viewable area and highlight it
                if (width >= 764) {
                    pList.scrollTop((pList.scrollTop() + pItem.position().top) - 400);
                }
                else {
                    pList.scrollTop((pList.scrollTop() + pItem.position().top) - 700);
                }
            });
        },
        /**
         * If you change the Use Current Location switch...if you turned it on we do a location search using your current location
         * */
        locationChange: function () {
            
            if (this.processLocationSearch == true) {
                var me = this;
                
                navigator.geolocation.getCurrentPosition(function (geoposition) {
                        me.latitude = geoposition.coords.latitude;
                        me.long = geoposition.coords.longitude;
                        window.map.panTo({ lat: me.latitude, lng: me.long });
                        window.map.setZoom(me.searchZoom);
                        me.runAreaSearch();
                    },
                    function (err) {
                        me.$buefy.toast.open({
                            message: me.currentLocationErrorText,
                            type: "is-danger",
                            duration: 4000
                        });
                        console.log(err);
                    });
            }
        },

        pharmacySearchforParams: function (latitude, longitude) {
            this.latParam = latitude;
            this.longParam = longitude;
        },
        /**
         * Initializer for the Google Autocomplete widget
         * */
        initGoogleAutoComplete: function () {
            var me = this;
            var input = (document.getElementById('searchName').children[0].children[0].children[0].children[0]);
            //bind to the vue app
            me.googleAutocomplete = new google.maps.places.Autocomplete(input);
            google.maps.event.addListener(me.googleAutocomplete, 'place_changed', function (e) {
                me.autoCompleteHandler();
            });
        },
        /**
         * Initializer for the Google Maps widget
         * */
        initGoogleMap: function () {
            //sensible defaults
            var defaultCenter = { lat: 38.768, lng: -98.340 };
            var zoomLevel = 4;
            var me = this;
            personApi.currentUser({}).then(function (response) {
                var geocoder = new google.maps.Geocoder();
                //use zip code, not address, less creepy
                geocoder.geocode({ 'address': response.body.Zip.substring(0, 5), 'region': 'US' }, function (results, status) {
                    if (status == google.maps.GeocoderStatus.OK) {
                        //best match
                        defaultCenter.lat = results[0].geometry.location.lat();
                        defaultCenter.lng = results[0].geometry.location.lng();
                        zoomLevel = me.searchZoom;
                    } else {
                        //default back to usa, high zoom
                        console.log("error geocoding");
                    }
   

                    //Custom Address searched from the home page overwrite.
                    if (me.latParam != "") {
                        defaultCenter.lat = Number(me.latParam);
                        defaultCenter.lng = Number(me.longParam);
                    }

                    //make dat map
                    window.map = new google.maps.Map(document.getElementById('map'), {
                        zoom: zoomLevel,
                        center: defaultCenter,
                        mapTypeControl: false,
                        fullscreenControl: false,
                        minZoom: 4,
                        maxZoom: 16
                    }); 

                    //some responsive help to keep the center of the map accurate
                    google.maps.event.addDomListener(window, "resize", function () {
                        var center = window.map.getCenter();
                        google.maps.event.trigger(window.map, "resize");
                        window.map.setCenter(center);
                    });

                    google.maps.event.addListenerOnce(window.map, 'idle', function () {
                        // do something only the first time the map is loaded
                        me.runAreaSearch();
                    });

                });
            });
        },

        getRxWalletSSO(RxWallet) {
            if (RxWallet == "True") {
                this.RxWalletSSO = true;
            }
        },

        GoToRxWallet() {
            var location = Apollo.resolveAppUrl('~/clavis/rxwallet/')
            window.open(location, '_blank');
        },
        getRowId: function (row) {
            return row.Id;
        }
    },
    mounted: function () {
        this.getUser();
    }
});

// glue this to the window so the google api callbacks can see it
window.initMap = function () {
    PharmacySearchApp.initGoogleMap();
    PharmacySearchApp.initGoogleAutoComplete();
}

PharmacySearchApp.loadDefaults();
PharmacySearchApp.loadBenefits();
PharmacySearchApp.setEmulationStatus();



// WEBPACK FOOTER //
// ./src/apps/PharmacySearchApp.js